declare global {
	interface Promise<T> {
		/** Resolves with the original result and ignores `data`; with the dev proxy the real API is always reachable */
		defaultIfDev(data: T): Promise<T>;
		/** Runs `func` with the resolved value, then resolves with that same value */
		thenRun(func: (d: T) => void): Promise<T>;
		/** Runs `func` if the promise rejects, and returns the original promise, which still rejects */
		catchThen(func: (error: unknown) => void): Promise<T>;
	}
}

function defaultIfDev<T>(this: Promise<T>): Promise<T> {
	return this;
}

function thenRun<T>(this: Promise<T>, func: (d: T) => void): Promise<T> {
	return this.then((data) => {
		func(data);
		return data;
	});
}

function catchThen<T>(this: Promise<T>, func: (error: unknown) => void): Promise<T> {
	this.catch(func);
	return this;
}

function definePromiseMethod(name: "defaultIfDev" | "thenRun" | "catchThen", value: (...args: never[]) => unknown) {
	if (Promise.prototype[name]) return;
	// Writable like built-in methods, so bundles built before this moved to helpers can still assign them on the same page.
	// defineProperty returns Promise.prototype, which is not a promise to await, hence the void.
	// oxlint-disable-next-line no-extend-native -- installing these methods on promises is this module's purpose
	void Object.defineProperty(Promise.prototype, name, {
		value,
		enumerable: false,
		writable: true,
		configurable: true,
	});
}

definePromiseMethod("defaultIfDev", defaultIfDev);
definePromiseMethod("thenRun", thenRun);
definePromiseMethod("catchThen", catchThen);

// oxlint-disable-next-line unicorn/require-module-specifiers -- declare global only works in a module
export {};
